import React, { createContext, useContext, useState } from 'react'

const AuthContext = createContext({})

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) throw new Error('useAuth must be used within AuthProvider')
  return context
}

export const AuthProvider = ({ children }) => {
  // Use sessionStorage to persist across page refreshes (cleared on tab close)
  const [token, setToken] = useState(() => {
    try { return sessionStorage.getItem('admin_token') } catch { return null }
  })

  const isAuthenticated = !!token

  const login = (jwtToken) => {
    setToken(jwtToken)
    try { sessionStorage.setItem('admin_token', jwtToken) } catch {}
  }

  const logout = () => {
    setToken(null)
    try { sessionStorage.removeItem('admin_token') } catch {}
  }

  const getAuthHeader = () => {
    return token ? { Authorization: `Bearer ${token}` } : {}
  }

  return (
    <AuthContext.Provider value={{ token, isAuthenticated, login, logout, getAuthHeader }}>
      {children}
    </AuthContext.Provider>
  )
}
